/* eslint-disable import/prefer-default-export */

export const getValidation = state => state.validation
